<div class="container-fluid container">

    <div class="row " style="margin-top: 200px;
    border: 1px solid #e8e8e8;
    padding: 20px;
    background-color: #f9f9f9;">

        <div class="col-md-2 text-right">

            <i class="fa fa-lock" style="
font-size: 58px;
    color: #aaa;
    border: 1px solid #dcdcdc;
    padding: 46px;
    border-radius: 100px;
    height: 90px;
    width: 90px;
    padding-left: 27px;
    padding-top: 13px;
"></i>

        </div>


        <div class="col-md-10 text-left">

            <h3 style="color:red;">Access Denied</h3>

            <p>Sorry, but you are not allowed to access this page, for more information please contact the system
                administrator.</p>


        </div>


    </div>
</div>

